import { AxiosResponse } from 'axios'

import { _axios } from 'hooks/axios'

const GET_COMPANY_BRANCH = `/company-branch`

export const companyBranchApi = () => {
  const getCompanyBranch = async (): Promise<
    AxiosResponse<{
      companyBranch: {
        id: string
        selectedShifts: number[]
      }
    }>
  > => {
    return await _axios().get(GET_COMPANY_BRANCH)
  }

  return {
    getCompanyBranch,
  }
}
